import React from 'react'
import Search from './Search'
import Dropdown from './DropDown'

function Header() {
  return (
    <div className='flex pt-[12px] px-[12px] pb-[24px] flex-col items-start'>
         <img className='mb-[8px]' src="/images/logo.png"/>
         <div className='flex flex-row gap-x-[16px]'>
            <Search/>
            <Dropdown/>
         </div>
    </div>
  )
}

export default Header